import { useQuery } from '@tanstack/react-query'

//TODO: some pagination and filtering is required, in this case will switch later to useInfinite scroll, this is test only
export const queryTemplates = () => { 

    const query = useQuery({
        queryKey: ['get-templates'],
        queryFn: async () => {
            const { data } = await axios.get(route('studio.internal.api.showcases.templates'));
            return data || [];
        },
    });

    return query;
}
